<template>
  <Modal :id="'cmp_distribution_order_xlsx_modal'" @cancelled="onCancelClick">
    <template slot="header"> </template>
    <template slot="body">
      <div style="height: 400px">
        <NTable
          id="distribution_order_xlsx"
          class="h1 dbox1"
          :config="tableConfig"
          :headers="headers"
          :items="rows"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('artist')">
                <span>{{ $t("artist") }}</span>
              </td>
              <td v-bind="tdcon('title1')">
                <span>{{ item["title"] }}</span>
              </td>
              <td v-bind="tdcon('format')">
                <span>{{ item["format"] }}</span>
              </td>
              <td v-bind="tdcon('catalog_no')">
                <span class="txtov">{{ item["catalog_no"] }}</span>
              </td>
              <td v-bind="tdcon('barcode')">
                <span class="txtov">{{ item["barcode"] }}</span>
              </td>
              <td v-bind="tdcon('qty')">
                <span>{{ item["order_qty"] }}</span>
              </td>
              <td v-bind="tdcon('select')">
                <Dropdown2
                  class="dbox1"
                  :showLabel="false"
                  :options="catalogOptions"
                  :placeholder="``"
                  :selected="
                    catalogOptions.find((v) => v.value == item.external_id)
                  "
                  v-on:selectedChange="
                    (e) => onDropDownChange('external_id', e, item)
                  "
                  :bb="'0px'"
                  deselect
                />
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s7 v1"  v-if="!loadingGif" @click="onEXClicked">{{$t('export')}}</button>
      <button
        v-if="loadingGif"
        class="dt-button v1 s6"
      >
        <img src="static/icons/loading.gif" />
      </button>
      <button class="dt-button s7" @click="onCancelClick">{{$t('close')}}</button>
      <button class="dt-button s7 v1" @click="onOKClicked">{{$t('add')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { closeModalRoute } from "../../../../dt-plugins/modal/modal.mixin";

import { createTV } from "../../../../models/text-value.model";

import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { statementGetters } from "../../store/statement/getters";
import { statementActions } from "../../store/statement/actions";

import { MHTTPCL } from "../../../../services/http/http-client";
import { OrderService } from "../../services/order.service";
import FileDownload from "js-file-download";
import { statementServices } from '../../../royalty/services/statements/statements.service';

export default {
  props: {
    rows: {
      type: Array,
    },
  },
  components: {
    Modal,
    NTable,

    ModalContainer,
  },
  mounted: async function () {
    const resCatalaog = await OrderService.physicalProducts();
    console.log(resCatalaog, "resCatalaog");

    this.catalogOptions = resCatalaog.data.catalogs.map((x) => {
      return {
        text: `${x.catalog_no} - ${x.format_name}`,
        value: x.product_id,
      };
    });
  },
  data: function () {
    return {
      catalogOptions: [],
      loadingGif:false,
    };
  },
  mixins: [],

  computed: {
    //...mapGetterObject(storeNS,statementGetters),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        headerStyle: 3,
      });
    },
    order_id:function(){
      return this.$route.query.order_id;
    },

    headers: function () {
      return [
        createTableHeader("artist", {}),
        createTableHeader("title1", { text: this.$t("title") }),
        createTableHeader("format", {}),
        createTableHeader("catalog_no", {}),
        createTableHeader("barcode", {}),
        createTableHeader("qty", { ta: "right" }),
        createTableHeader("select", {}),
      ];
    },
  },
  methods: {
    //...mapActionObject(storeNS, statementActions),

    closeModal: function () {
      closeModalRoute(this);
    },

    onDropDownChange: async function (name, e, item) {
      console.log({ name, e, item });
    },
    onEXClicked:async  function () {
      try{
      this.loadingGif=true;
      console.log
      const resData =await  OrderService.exportUnmatchedOrderlinesOnImport(
        this.order_id,
       this.rows
      )
      this.loadingGif=false;
      // .then(res=>{
      //   FileDownload(res.data, `unmatched_product_from_${order_id}.xlsx`);  
      // });
      console.log( resData, ":::::::::::::::");
      FileDownload(resData.data, `unmatched_product_from_${this.order_id}.xlsx`);
      }
      catch{
        this.loadingGif=false;
      }
      
      
    },

    onOKClicked: function () {
      statementServices.updateShopNames();
      this.onCancelClick();
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp_distribution_order_xlsx_modal {
}
</style>